export { getAvatarIcon } from "./avatar";
export { getFavicon } from "./favicon";
export { getProgressIcon } from "./progress";
